import { SVGUniqueID } from './svg-unique-id';
import type { IconProps } from './types';
const Icon = (props: IconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    width={props.size || 24}
    height={props.size || 24}
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.00354 9.61876C2.03581 9.71557 2.09749 9.79988 2.17999 9.85994L6.99999 13.9999L5.55999 20.2499C5.53614 20.3472 5.54144 20.4493 5.57522 20.5435C5.60901 20.6378 5.66979 20.72 5.74999 20.7799L5.96999 20.9299C6.05267 20.9858 6.15019 21.0157 6.24999 21.0157C6.34979 21.0157 6.44731 20.9858 6.52999 20.9299L12 17.5999L17.44 20.8999C17.5227 20.9558 17.6202 20.9857 17.72 20.9857C17.8198 20.9857 17.9173 20.9558 18 20.8999L18.29 20.7399C18.3702 20.68 18.431 20.5978 18.4648 20.5035C18.4985 20.4093 18.5038 20.3072 18.48 20.2099L17 13.9999L21.82 9.85994C21.8972 9.79607 21.953 9.71006 21.9798 9.61351C22.0066 9.51695 22.0032 9.41449 21.97 9.31994L21.89 9.06994C21.8614 8.9735 21.8039 8.88818 21.7252 8.82556C21.6465 8.76294 21.5504 8.72607 21.45 8.71994L15.06 8.20994L12.6 2.31994C12.5647 2.22435 12.5004 2.14216 12.4162 2.0848C12.3319 2.02744 12.2319 1.99778 12.13 1.99994H11.87C11.762 1.99226 11.6544 2.01913 11.5627 2.07666C11.471 2.13418 11.4 2.21939 11.36 2.31994L8.90999 8.20994L2.51999 8.71994C2.41959 8.72607 2.32351 8.76294 2.2448 8.82556C2.16608 8.88818 2.10854 8.9735 2.07999 9.06994L1.99999 9.31994C1.97003 9.41749 1.97127 9.52195 2.00354 9.61876Z"
      fill={props.color || 'currentColor'}
    />
  </svg>
);
const SvgStar = (props: IconProps) => <SVGUniqueID>{Icon(props)}</SVGUniqueID>;
export default SvgStar;
